// test763
(763 && 0);
